// extracted by mini-css-extract-plugin
module.exports = {"lg_box":"Home_lg_box__aMj7u","lg_card":"Home_lg_card__g2yDj"};